import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const SUCCESS_HEIGHT = '250px';
const LOADING_HEIGHT = '400px';
const DEFAULT_HEIGHT_DESKTOP = '720px';

const transientProps = (prop) => !['$isSubmitted', '$isLoading', '$isModal'].includes(prop);

export const IframeWrapper = styled(Box, {
  shouldForwardProp: transientProps,
})(({ theme, $isSubmitted, $isLoading, $isModal }) => ({
  width: '100%',
  position: 'relative',
  borderRadius: '12px',
  overflow: 'hidden',
  minHeight: $isLoading ? LOADING_HEIGHT : 'auto',

  '& iframe': {
    width: '100%',
    height: $isSubmitted ? SUCCESS_HEIGHT : DEFAULT_HEIGHT_DESKTOP,
    border: 'none',
    borderRadius: '12px',
    display: 'block',
    transition: 'height 0.5s ease, opacity 0.3s ease',
    overflow: $isSubmitted ? 'hidden' : 'auto',
    opacity: $isLoading ? 0 : 1,
    [theme.breakpoints.down(1139)]: {
      height: $isSubmitted ? SUCCESS_HEIGHT : 1000,
    },
    [theme.breakpoints.down(900)]: {
      height: $isSubmitted ? SUCCESS_HEIGHT : DEFAULT_HEIGHT_DESKTOP,
    },
    [theme.breakpoints.down(842)]: {
      height: $isSubmitted ? SUCCESS_HEIGHT : 1000,
    },
    [theme.breakpoints.down(690)]: {
      height: $isSubmitted ? SUCCESS_HEIGHT : 1000,
    },
  },

  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    pointerEvents: 'none',
  },
}));

export const LoadingOverlay = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 2,
  borderRadius: '12px',
});
